<template>
  <div class="case-detail-gene-publication-dailog dialog col-block">
    <div class="title-container row-block">
      <div class="title">{{ 'Publications'/* ___ */ }}</div>
      <div :style="{ flex: 1 }"></div>
    </div>
    <div :style="{ height: '20px' }"></div>
    <div class="data-container col-block" v-for="(variant, vindex) in variants" :key="vindex">
      <div class="data-title-container row-block">
        <div class="data-title">{{ variant.transcripts[variant.Feature] ? variant.transcripts[variant.Feature].HGVSc && !variant.transcripts[variant.Feature].HGVSc.includes(':') ? !variant.CHROM.startsWith('chrM') && !variant.Feature ? variant.transcripts[variant.Feature].HGVSc : variant.Feature + ':' + variant.transcripts[variant.Feature].HGVSc : variant.transcripts[variant.Feature].HGVSc : '- -' }}</div>
        <div :style="{ flex: 1 }"></div>
      </div>
      <div :style="{ height: '15px' }"></div>
      <div class="data-content-container col-block">
        <div class="data-row row-block stretch">
          <div class="data-col col-block" v-for="(option, oindex) in tableOption" :key="oindex" :class="[option.position]" :style="option.width ? { width: option.width } : { flex: 1 }">
            <div :style="{ flex: 1 }"></div>
            <div class="data-content" v-html="option.title"></div>
            <div :style="{ flex: 1 }"></div>
          </div>
        </div>
        <div class="data-row row-block stretch">
          <div class="data-col col-block" v-for="(option, oindex) in tableOption" :key="oindex" :class="[option.position]" :style="option.width ? { width: option.width } : { flex: 1 }">
            <div :style="{ flex: 1 }"></div>
            <div v-if="option.value === 'publication'" class="table-content publications-container">
              <template v-if="variant.publications && Object.keys(variant.publication).length">
                <div class="publication-block col-block" v-for="(publication, id, pindex) in gene.publications" :key="pindex">
                  <div class="publication-title" v-html="publication.title"></div>
                  <div :style="{ height: '5px' }"></div>
                  <a :href="publication.pub_url" class="publication-link row-block" target="_blank">
                    <div class="link-title">{{ 'PMID:' + id + '  ' + publication.source + '  ' + publication.epubdate }}</div>
                    <div :style="{ width: '10px' }"></div>
                    <img :src="require('../../assets/images/external-link-icon.svg')" alt="">
                  </a>
                  <div :style="{ height: '5px' }"></div>
                  <div class="publication-info">{{ publication.auhtors.join(', ') }}</div>
                </div>
              </template>
              <div v-html="option.empty"></div>
            </div>
            <div v-else class="data-content" :style="option.color ? { color: option.color(variant) } : {}" v-html="option.value(variant) || option.empty || '- -'"></div>
            <div :style="{ flex: 1 }"></div>
          </div>
        </div>
      </div>
    </div>
    <div :style="{ height: '20px' }"></div>
    <div class="button-container row-block">
      <div :style="{ flex: 1 }"></div>
      <button class="gray-button circle-button" @click="e => $emit('changeModal')">
        <span>{{ 'Return'/* ___ */ }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    variants () {
      return this.param.variants
    },
    // static
    tableOption () {
      return [
        {
          title: 'Publications'/* ___ */,
          value: variant => variant.publication,
          color: null,
          width: null,
          position: 'left',
          empty: 'N/A'/* ___ */
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/caseDetailGenePublication.vue